var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecoil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-23.206 -5.92 429.252 916.587",
    style: {
      enableBackground: "new 0 0 2546.8 901.7"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C1E21;}\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,393c6.7-1.4,13.6-2.4,20.5-3l0,0l0,0l53.6-5.1l-72.8-79.8c-21.9-24.1-34-55.3-34-87.9H4.4 c0,47.6,17.7,93.3,49.8,128.5L97.3,393z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.3,509.9c-5.4,1-10.9,1.7-16.4,2.3l0,0l0,0l-58,5.5l72.6,79.6c21.9,24.1,34,55.3,34,87.9h60.3 c0-47.6-17.7-93.2-49.8-128.5L285.3,509.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385,333c-9.9-49.2-48.5-85-98.3-91.3l-9.2-1.2c-31.1-3.9-54.6-30.5-54.6-61.8v-32.1c27.6-11.5,47-38.7,47-70.4 c0-42.1-34.1-76.2-76.2-76.2s-76.2,34.1-76.2,76.2c0,31,18.6,57.7,45.2,69.6v32.9c0,61.7,46.1,114,107.3,121.6l9.2,1.2 c28.7,3.6,43,24.8,46.8,43.4c3.8,18.6-1.1,43.7-26.2,58.2c-12.3,7.1-25.6,11.4-39.7,12.7l-138.3,13c-22.8,2.2-44.4,9.1-64.2,20.5 C14.1,474.5-7.6,522.5,2.4,571.7c9.9,49.2,48.5,85,98.3,91.3l9.2,1.2c31.1,3.9,54.6,30.5,54.6,61.8v29.2 c-27.5,11.5-46.8,38.7-46.8,70.3c0,42.1,34.1,76.2,76.2,76.2s76.2-34.1,76.2-76.2c0-31.1-18.7-57.9-45.4-69.7v-29.8 c0-61.7-46.1-114-107.3-121.6l-9.2-1.2c-28.7-3.6-43-24.8-46.8-43.4c-3.8-18.6,1.1-43.7,26.2-58.2c12.3-7.1,25.6-11.4,39.7-12.7 l138.3-13c22.8-2.2,44.4-9.1,64.2-20.5C373.3,430.2,394.9,382.2,385,333z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoil);
export default __webpack_public_path__ + "static/media/recoil.5c66aad7488e08ecb167bc23a3412216.svg";
export { ForwardRef as ReactComponent };